export const ROLE_ROOT = 'root';
export const ROLE_GUEST = 'guest';
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 10000000;
export const DEFAULT_SCHEDULER_TABLE_PAGE_SIZE = 5;
export const DEFAULT_SEED_PEER_TABLE_PAGE_SIZE = 5;
export const DEFAULT_PERSISTENT_CACHE_TASK_PERRS_PAGE_SIZE = 5;
